import { render } from "./studioCourse.vue?vue&type=template&id=92daf87c&scoped=true"
import script from "./studioCourse.vue?vue&type=script&lang=js"
export * from "./studioCourse.vue?vue&type=script&lang=js"

import "./studioCourse.vue?vue&type=style&index=0&id=92daf87c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92daf87c"]])

export default __exports__